import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import IntersectionWrapper from "components/common/intersection-wrapper"
import { retry } from "helpers/application"

import ProductRecommendations from "./product-recommendations"
import RecentlyViewed from "./recently-viewed"

const ProductGallery = loadable(() =>
  retry(() => import("areas/product/jewlr/product-gallery"))
)
const StampedReviewsWidget = loadable(() =>
  retry(() => import("components/stamped-reviews-widget"))
)
const CocoonNecklace = loadable(() =>
  retry(() => import("./info/cocoon-necklace"))
)
const DeliverValue = loadable(() => retry(() => import("./info/deliver-value")))
const EthicallySourced = loadable(() =>
  retry(() => import("./info/ethically-sourced"))
)
// const Packaging = loadable(() => retry(() => import("./info/packaging")))
const Perks = loadable(() => retry(() => import("./info/perks")))
const QualityWatches = loadable(() =>
  retry(() => import("./info/quality-watches"))
)
const QrCodeNecklace = loadable(() =>
  retry(() => import("./info/qrcode-necklace"))
)
const WildlifeFoundation = loadable(() =>
  retry(() => import("./info/wildlife-foundation"))
)
const CustomerReviews = loadable(() =>
  retry(() => import("./info/customer-reviews"))
)

const InternalProductFooter = ({
  hasDiamondSelector,
  hasFreeResizing,
  isAccessory,
  is_watches,
  stampedProductId,
  styleCode,
}) => {
  return (
    <div className="bg-grey-4 tablet:bg-white">
      <div className="bg-white">
        {styleCode === "JWLP0578" && (
          <IntersectionWrapper>
            <div className="contained">
              <WildlifeFoundation />
            </div>
          </IntersectionWrapper>
        )}
        {styleCode === "JWLN0593" && (
          <IntersectionWrapper>
            <div className="contained">
              <QrCodeNecklace />
            </div>
          </IntersectionWrapper>
        )}
        {styleCode === "JWLP0614" && (
          <IntersectionWrapper>
            <div className="contained">
              <CocoonNecklace />
            </div>
          </IntersectionWrapper>
        )}
        {!isAccessory && (
          <IntersectionWrapper>
            <div className="contained desktop:max-w-1440 tablet:px-0">
              <ProductRecommendations />
            </div>
          </IntersectionWrapper>
        )}
        {!isAccessory && (
          <IntersectionWrapper>
            <div className="contained">
              <ProductGallery stampedProductId={stampedProductId} />
            </div>
          </IntersectionWrapper>
        )}
        {is_watches && (
          <IntersectionWrapper>
            <QualityWatches />
          </IntersectionWrapper>
        )}
        <IntersectionWrapper>
          <Perks
            hasDiamondSelector={hasDiamondSelector}
            hasFreeResizing={hasFreeResizing}
          />
        </IntersectionWrapper>
        {/* {!hidePackaging && (
              <IntersectionWrapper>
                <Box contain>
                  <Packaging />
                </Box>
              </IntersectionWrapper>
            )} */}
      </div>
      <IntersectionWrapper>
        <div className="contained">
          <DeliverValue />
        </div>
      </IntersectionWrapper>
      {!is_watches && (
        <IntersectionWrapper>
          <EthicallySourced />
        </IntersectionWrapper>
      )}
      <div id="product-reviews">
        <IntersectionWrapper>
          <CustomerReviews />
          <div className="contained tablet:px-0 px-16 text-left">
            <StampedReviewsWidget
              stampedProductId={stampedProductId}
              styleCode={styleCode}
            />
          </div>
        </IntersectionWrapper>
      </div>
      <RecentlyViewed />
    </div>
  )
}

InternalProductFooter.propTypes = {
  hasDiamondSelector: PropTypes.bool,
  hasFreeResizing: PropTypes.bool,
  isAccessory: PropTypes.bool,
  is_watches: PropTypes.bool,
  productType: PropTypes.string,
  stampedProductId: PropTypes.string,
  styleCode: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    hasDiamondSelector: state.wizard.hasDiamondSelector,
    hasFreeResizing: state.wizard.description.product_resizable,
    isAccessory: state.wizard.description.product_type === "ACCESSORY",
    is_watches: state.wizard.description.is_watches,
    productType: state.wizard.description.product_type,
    stampedProductId: state.wizard.stampedProductId,
    styleCode: state.choices.style_code && state.choices.style_code.value,
  }
}

const ProductFooter = connect(mapStateToProps)(InternalProductFooter)

export default ProductFooter
